// TODO FSSP remove fssp registation in monitoring. remove monitoring registration in fssp
export const routeCodes = {
  RECTOR: '/rector',
  RECTOR_STATISTICS: '/rector-statistics',
  AUTH: '/auth',
  // AUTH: '/auth',
  AUTH_PAGE: '/temporary-auth',
  MASTER: '/master/:department/:position/:role',
  AUTH_FORMS: '/auth/:department',
  VK_AUTH_CONFIRM_DEPARTMENT: '/vkconfirmdepartment/:department',
  AUTH_INDIVIDUAL: '/auth/:department/:position/:quizId',
  AUTH_INDIVIDUAL_WITH_ROLE: '/auth/:department/:position/:quizId/:role',
  // AUTH_EVENTS: '/auth/:department/:position/:quizId',
  LOGIN: '/login',
  LOGIN_INDIVIDUAL: '/login/:department/:position/:quizId',
  RESET_PASSWORD: '/login/reset',
  SET_NEW_PASSWORD: '/login/newpassword',
  REPEAT_CODE: '/repeat-code',
  REGISTRATION_LEADERSHIPS: '/registration/:position',
  REGISTRATION_FORMS: '/reg/:department',
  REGISTRATION: '/registration/:department/:position',
  REGISTRATION_INDIVIDUAL: '/registration/:department/:position/:quizId',
  FSSP_REGISTRATION: '/registration',
  USER_AGREEMENT: '/user-agreement',
  USER_CONFIRM: '/user-confirm',
  REGISTRATION_INSTRUCTION: '/registration-instruction',
  DASHBOARD: '/dashboard',
  SURVEYS: '/surveys',
  QUIZ: '/surveys/:quizId',
  QUIZ_RESULTS: '/surveys/:quizId/results',
  PROMO: '/promo',
  PROFILE_NEW: '/myprofile',
  MESSENGER: '/messenger',
  WORLD: '/world',
  WORLD_TESTS: '/world/tests',
  TEST_RESULTS: '/world/results',
  OPPORTUNITIES: '/opportunities',
  REWARDS_SHOP: '/rewards-shop',
  SOCIAL_CAPITAL: '/social-capital',
  MY_OPPORTUNITIES: '/my-opportunities',
  ROSNAVYK: '/rosnavyk',
  ROSNAVYK_STATISTICS: '/rosnavyk/statistics',
  LEADERID: '/leader',
  EVENTS: '/events',
  MY_REWARDS: '/my-rewards',
  EVENTS_CHECK_REGISTER: '/meetings/check-register/:meetingId/:userId',
  NEWS_PAGE: '/news',
  NEWS: '/news/:newsId',
  FEEDBACK: '/feedback',
  TOP_MANAGER: '/top-manager',
  SUPPORT: '/support'
}
